import { render, staticRenderFns } from "./FormAddPlan.vue?vue&type=template&id=3b088678&scoped=true"
import script from "./FormAddPlan.vue?vue&type=script&lang=js"
export * from "./FormAddPlan.vue?vue&type=script&lang=js"
import style0 from "./FormAddPlan.vue?vue&type=style&index=0&id=3b088678&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b088678",
  null
  
)

export default component.exports